<template>
    <div class="uk-padding uk-margin-remove-top uk-background-muted" >
        <div class="uk-container ">

            <h2 class="uk-heading-bullet uk-text-bold">
                <span class="">Our Departments</span>
            </h2><br>

            <div class="uk-child-width-1-2@m " uk-grid>
                <div>
                    <img src="../../../assets/cnm_link_bg.jpg" class="uk-align-center "
                         style="max-height: 400px; max-width: 400px; height: auto; width: auto; border-radius: 10px" alt="">
                </div>
                <div>
                    <div class=""><br>
                        <p class="uk-text-lead">Go to our department website to learn more about us.</p>
                        <a class="uk-button uk-button-secondary  uk-text-capitalize uk-margin-small-right"
                           href="http://bhm.ncu.edu.jm" target="_blank"
                           style="background-color: #033860; border-radius: 10px; color: rgba(255, 215, 3,0.9); font-size: medium">Go to department ..</a>
                        <router-link to="/alldepartments" class="uk-button uk-button-secondary uk-text-bold uk-text-capitalize"
                                     style=" background-color: rgba(255, 215, 3,0.9); border-radius: 10px; color: #033860; font-size: medium"
                        >See All Departments</router-link>
                    </div>
                </div>
            </div>

            <div>
                <br><br>
                <div class="uk-text-center">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cbmDepartmentLinks",
        data() {
            return {
                hover: false,
                hover1: false,
                hover2: false,
                hover3: false,
                hover4: false,
                hover5: false,
                hover6: false,
            };
        }
    }
</script>

<style scoped>
    .half-a-border-on-top {
        border-top: 2px solid gold;
        position: relative;
        color: #033860 ;

    }
    .half-a-border-on-top:after {
        padding-top: 10px;
        content: "";
        width:50%;
        height: 3px;/* slight higher to work around rounding errors(?) on some zoom levels in some browsers. */
        background-color: white;
        position: absolute;
        right:0;
        top:-2px;
    }
    .active {
        background-color: rgba(11, 11, 11,0.6) !important;

        transition: 1.0s;
        opacity: 1
    }
    .active:hover{
        opacity: 1;
        background-color: rgba(3, 56, 96,1) !important;
    }
    .active h4, .active button{
        color: #c0c0c0 !important;
        font-weight: bold;
    }
    .smoothEdge{
        border-radius: 5px;
    }
    h5{
        color: gold;
        font-weight: bolder;
    }
</style>